/**
 * Intercom-style saved replies: shortcut (typed as /shortcut), title, body with merge tags.
 * Supported tags: {{first_name}}, {{full_name}}, {{company_name}}, {{email}}
 */
export const INITIAL_CANNED_RESPONSES = [
  {
    id: "cr-1",
    shortcut: "hello",
    title: "Warm greeting",
    body: "Hi {{first_name}},\n\nThanks for reaching out — I'm happy to help today.",
  },
  {
    id: "cr-2",
    shortcut: "thanks",
    title: "Closing thanks",
    body: "Thanks again for your patience, {{first_name}}. If anything else comes up, just reply here and we'll pick it up.",
  },
  {
    id: "cr-3",
    shortcut: "away",
    title: "Short wait",
    body: "I'm looking into this for you now and will follow up shortly with an update.",
  },
];
